import { render } from "./TeamLayout.vue?vue&type=template&id=4691d73e&scoped=true"
import script from "./TeamLayout.vue?vue&type=script&lang=js"
export * from "./TeamLayout.vue?vue&type=script&lang=js"

import "./TeamLayout.vue?vue&type=style&index=0&id=4691d73e&lang=scss"
import "./TeamLayout.vue?vue&type=style&index=1&id=4691d73e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4691d73e"

export default script